export default "__VITE_ASSET__B9Rh9PYo__"